<div
  #chartContainer
  class="w-full min-h-[350px] h-full relative chart-container-class"
></div>
